<template>
  <div class="ma-4">
    <v-card>
      <v-card-title class="py-2 px-4">
        <span class="text-h6 font-weight-medium">Roles and Permissions</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          dense
          outlined
          rounded
          class="custom-search-field"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="users"
        :search="search"
        :items-per-page="5"
        item-key="name"
        :expanded.sync="expanded"
        show-expand
        class="elevation-0"
      >
        <template v-slot:item.permission="{ item }">
          <v-btn
            v-if="item.permission"
            small
            color="primary"
            class="text-none px-4"
            depressed
            @click="openPermissionDialog(item)"
          >
            View
          </v-btn>
        </template>
        <template v-slot:item.users="{ item }">
          <div class="user-avatars">
            <v-avatar
              v-for="(user, index) in item.users.slice(0, 5)"
              :key="index"
              size="45"
              :style="{
                zIndex: 5 - index,
                marginLeft: index > 0 ? '-12px' : '0',
              }"
              class="user-avatar"
              @click="toggleExpand(item)"
            >
              <span class="white--text text-subtitle-2">{{
                user.initials
              }}</span>
            </v-avatar>
            <v-avatar
              v-if="item.users.length > 5"
              size="45"
              color="grey lighten-2"
              :style="{
                zIndex: 0,
                marginLeft: '-8px',
              }"
              class="user-avatar"
              @click="toggleExpand(item)"
            >
              <span class="grey--text text-subtitle-2"
                >+{{ item.users.length - 5 }}</span
              >
            </v-avatar>
          </div>
        </template>
        <template v-slot:item.actions="{}">
          <v-btn icon small>
            <v-icon small>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-0">
            <v-list class="expanded-list py-0">
              <v-list-item
                v-for="user in item.users"
                :key="user.email"
                class="py-2"
              >
                <v-list-item-avatar size="32">
                  <v-avatar size="32" color="grey lighten-1">
                    <span class="white--text text-subtitle-2">{{
                      user.initials
                    }}</span>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 font-weight-medium">{{
                    user.name
                  }}</v-list-item-title>
                  <v-list-item-subtitle class="caption">{{
                    user.email
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon x-small color="grey lighten-1">
                    <v-icon x-small>mdi-open-in-new</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </td>
        </template>
      </v-data-table>
    </v-card>

  <permission-dialog
      v-model="dialogVisible"
      :current-role="currentRole"
      :permission="permission"
      @save="handleSavePermissions"
    />
  </div>
</template>

<script>
import axios from "axios";
import PermissionDialog from "@/components/RolesPermission/PermissionDialog.vue";
const url = require("../client_config/config").url;
export default {
   components: {
    PermissionDialog,
  },
  data() {
    return {
      search: "",
      user: [],
      expanded: [],
      position: [
        "Administration", 
        "Direct Care Staff", 
        "Shift Lead", 
        "Assistant Manager", 
        "House Manager", 
        "Program Manager",
        "Human Resources", 
        "Client Services Manager", 
        "Program Coordinator", 
        "Medical Manager", 
        "Executive Director",
        "Finance Manager", 
        "Compliance Manager", 
        "Parent / Guardian", 
        "Support Coordinator", 
        "Client", 
        "Pharmacy"
      ],
      permission:[
        "Dashboard", 
        "Schedule", 
        "Staff", 
        "Clients", 
        "Reports", 
        "Calendar", 
        "Training", 
        "Tasks", 
        "Maintenance",
        "Vehicles", 
        "Providers", 
        "Payroll"
      ],
      headers: [
        { text: "Role name", value: "name", width: "30%" },
        { text: "Permission", value: "permission", width: "20%" },
        { text: "Users", value: "users", width: "40%" },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
        { text: "", value: "data-table-expand" },
      ],
      users: [
        {
          name: "Admin",
          permission: null,
          users: [
            {
              initials: "JJ",
              name: "Jezrell Jolampong",
              email: "admin@demo.com",
            },
            { initials: "BT", name: "Brian Tryrell", email: "admin@demo.com" },
            { initials: "BH", name: "Bradley Hall", email: "admin@demo.com" },
          ],
        },
        {
          name: "Direct Care Staff",
          permission: "View",
          users: [
            {
              initials: "GB",
              name: "Glacel Babe Billones",
              email: "directcarestaff@demo.com",
            },
          ],
        },
        {
          name: "Program Manager",
          permission: "View",
          users: [
            {
              initials: "EP",
              name: "Eric Papas",
              email: "programmanager@demo.com",
            },
          ],
        },
        {
          name: "Shift Manager",
          permission: "View",
          users: [
            { initials: "CD", name: "Calin Dalino", email: "shift1@demo.com" },
            {
              initials: "GB",
              name: "Gisel Billones",
              email: "shift2@demo.com",
            },
            { initials: "KI", name: "Kenith Iran", email: "shift3@demo.com" },
          ],
        },
        {
          name: "House Manager",
          permission: "View",
          users: [
            {
              initials: "JD",
              name: "Jason Dale",
              email: "housemanager@demo.com",
            },
          ],
        },
      ],
      dialogVisible: false,
      currentRole: null,
      permissionItems: [
        {
          name: "Dashboard",
          children: [{ name: "Can view dashboard page" }],
        },
        {
          name: "Users",
          children: [
            { name: "Can view list of user" },
            { name: "Can create an user" },
            { name: "Can update an user" },
            { name: "Can delete an user" },
          ],
        },
        {
          name: "Programs",
          children: [
            { name: "Can view list of program" },
            { name: "Can create an program" },
            { name: "Can update an program" },
            { name: "Can delete an program" },
          ],
        },
      ],
    };
  },
 created() {
    this.getUserRole();
    this.users = this.position.map((positionName) => {

    const existingRole = this.users.find(
      (user) => user.name === positionName
    );

    return existingRole || {
       name: positionName,
       permission: positionName === "Administration" ? null : "View",
       users: [],        
    };
  });
 },
  
  methods: {
    viewPermission(item) {
      console.log("View permission for", item.name);
    },
    toggleExpand(item) {
      const index = this.expanded.indexOf(item);
      if (index === -1) {
        this.expanded.push(item);
      } else {
        this.expanded.splice(index, 1);
      }
    },
  openPermissionDialog(item) {
    this.currentRole = item;
    this.dialogVisible = true;
  },
    savePermissions() {
      console.log("Saving permissions for", this.currentRole.name);
      this.dialogVisible = false;
    },
     handleSavePermissions(role) {
      const permissionData = [
        {
          role: role.name,
          permissions: [
            {
              page: "Schedule",
              actions: {
                view: true,
                create: true,
                update: true,
                delete: true,
              },
            },
            {
              page: "Staff",
              actions: {
                view: true,
                create: true,
                update: true,
                delete: true,
              },
            },
          ],
        },
      ];
      console.log("Saving permissions for", permissionData);
    },
    getUserRole: function() {
      axios.get(`${url}/users`).then((res) => {
        const fetchedUsers = res.data.users;

        const usersWithInitials = fetchedUsers.map(user => {
       
          const nameParts = user.Name.split(" ");
          const initials = nameParts.length > 1
            ? nameParts[0][0] + nameParts[nameParts.length - 1][0] // First letter of first and last names
            : nameParts[0][0]; // Only one name part (fallback to the first letter)

          return {
            ...user,
            initials: initials.toUpperCase(),
            name : user.Name,
            email: user.Email
          };
        });

        this.users = this.users.map(roleGroup => {
          const matchedUsers = usersWithInitials.filter(user => user.Role === roleGroup.name);

          return {
            ...roleGroup,
            users: matchedUsers.length ? matchedUsers : roleGroup.users // Fallback to predefined users if no match
          };
        });
      });
    },
  },
};
</script>

<style scoped>
.user-avatars {
  display: flex;
  align-items: center;
}

.user-avatar {
  border: 2px solid #fff;
  background-color: #bdbdbd !important;
  cursor: pointer;
}

.custom-search-field {
  max-width: 250px;
}

.expanded-list {
  background-color: #f5f5f5;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  height: 60px;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr.v-data-table__expanded__content {
  box-shadow: inset 0 4px 4px -4px rgba(0, 0, 0, 0.1),
    inset 0 -4px 4px -4px rgba(0, 0, 0, 0.1);
}

::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.6);
}
</style>
